import React from 'react';
import {
	UncontrolledTooltip,
	NavbarBrand,
} from 'reactstrap';
import Logout from '../Logout';
import AuthService from '../../services/AuthService';
import ActiveView from './ActiveView';
import GlobalSearch from './GlobalSearch';
import Settings from './Settings';
import Notifications from './Notifications';

class Header extends React.Component {

	constructor(props) {
		super(props)

		this.state = {
			dropdownOpen: false
		}
		this.toggle = this.toggle.bind(this);
		this.openHelpForm = this.openHelpForm.bind(this);
		this.openHelpFormKeyup = this.openHelpFormKeyup.bind(this);
		this.onDropdownClick = this.onDropdownClick.bind(this);
	}

	toggle() {
		this.setState({ dropdownOpen: !this.state.dropdownOpen })
	}

	sidebarToggle(e) {
		e.preventDefault()
		document.body.classList.toggle('sidebar-hidden')
	}

	sidebarMinimize(e) {
		e.preventDefault()
		document.body.classList.toggle('sidebar-minimized')
	}

	mobileSidebarToggle(e) {
		e.preventDefault()
		document.body.classList.toggle('sidebar-mobile-show')
	}

	asideToggle(e) {
		e.preventDefault()
		document.body.classList.toggle('aside-menu-hidden')
	}

	onDropdownClick(e) {
		e.preventDefault();

		const url = e.target.dataset && e.target.dataset.url ? e.target.dataset.url : null;

		if (url) {
			if (url === 'login') AuthService.logout();
			this.props.history.push('/' + url);
			// window.location.href = url;
		}
	}

	openHelpForm() {
		this.props.help();
	}

	openHelpFormKeyup(e) {
		if (e.keyCode === 13) this.openHelpForm();
	}

	render() {
		return (
			<header className={'app-header navbar' + (this.props.external ? ' ext-login' : '')}>
				<div className="header-content">
					<div className="row">
						<div className="col">
							<div className="row">
								<div className="col-3 pr-0">
									<NavbarBrand href="https://www.corlytics.com" target="_blank" alt="Corlytics">
										<span className="visually-hidden">Corlytics</span>
									</NavbarBrand>
								</div>
								<div className="col-6 pl-0 text-center">
									<ActiveView history={this.props.history} />
								</div>
								<div className="col-3 text-centre float-right">
									<Settings history={this.props.history} />
									<i
										className="fa fa-question-circle helpform-button pull-right"
										onClick={this.openHelpForm}
										onKeyUp={this.openHelpFormKeyup}
										tabIndex="0"
										id="support-ttip"
									></i>
									<UncontrolledTooltip placement="top" target={'support-ttip'} >Corlytics Support</UncontrolledTooltip>
									<Notifications history={this.props.history} />
								</div>
								{/* <GlobalSearch history={this.props.history} /> */}
							</div>
						</div>
					</div>
					{/* <NavbarToggler className="d-lg-none" onClick={this.mobileSidebarToggle}>&#9776;</NavbarToggler> */}
					{/* <NavbarToggler className="d-md-down-none mr-auto" onClick={this.sidebarToggle}>&#9776;</NavbarToggler> */}

					{/* <HeaderIcons /> */}

					{/* <button type="button" className="btn btn-outline-dark helpform-button" onClick={this.openHelpForm}>Get Support</button> */}


					{/* <ul className="nav navbar-nav ml-auto user-menu-dropdown">
						<li className="nav-item">
							<Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} onClick={this.onDropdownClick}>
								<button onClick={this.toggle} className="nav-link dropdown-toggle" data-toggle="dropdown" type="button" aria-haspopup="true" aria-expanded={this.state.dropdownOpen}>
									<span className="d-md-down-none">Settings&nbsp;</span>
								</button>

								<DropdownMenu className="dropdown-menu-right">
									<DropdownItem header className="text-center"><strong>Settings</strong></DropdownItem>

									<DropdownItem data-url="preferences">
										<i className="fa fa-user"></i>
										<Link to="/preferences">Preferences</Link>
									</DropdownItem>
									<DropdownItem data-url="login"><i className="fa fa-lock"></i><Logout /></DropdownItem>
								</DropdownMenu>
							</Dropdown>
						</li>
					</ul> */}
				</div>
			</header>
		)
	}
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/Header.js